
export function validateNote(note: string){

    let result = note;

    // Limit number of spaces
    result = result.replace(/  +/g, ' ');

    return result;
}